import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { useGlobalAuth } from '../auth-provider';

const SessionMetadataResponse = z.object({
  usIsMerged: z.boolean(),
  usRegistrationEnabled: z.boolean(),
});
type SessionMetadataResponse = z.infer<typeof SessionMetadataResponse>;

const fetchSessionMetadata = async (): Promise<SessionMetadataResponse> => {
  const res = await fetch('/api/global-auth/session-metadata');
  if (!res.ok) return { usIsMerged: false, usRegistrationEnabled: false };
  return SessionMetadataResponse.parse(await res.json());
};

export const useGlobalAuthMergedStatus = (options?: { enabled?: boolean }) => {
  const { viewer } = useGlobalAuth();
  const sessionId = viewer?.isAuthenticated
    ? (viewer.info as { id?: string })?.id
    : undefined;

  return useQuery({
    queryKey: ['global-auth', 'session-metadata', sessionId],
    queryFn: fetchSessionMetadata,
    enabled: (options?.enabled ?? true) && sessionId !== undefined,
    staleTime: 5 * 60 * 1000,
  });
};
